<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>{{ practiceRegionName }}</h1>
  <div>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <div *ngIf="!loading" formGroupName="ValorizationItem">
      <mat-form-field
        *ngIf="!data.noUpdateQuantity"
        formGroupName="MedicalAppointmentProcedure"
        class="card-inline margin-right-small"
      >
        <mat-label>Cantidad</mat-label>
        <input type="number" matInput formControlName="Quantity" min="0" required />
        <mat-error *ngIf="!fMedicalAppointmentProcedure.Quantity.valid">
          Ingrese la cantidad
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="!isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Honorarios</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="FeeCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.FeeCoverage.errors &&
            fValorizationItem.FeeCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura honorarios
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="!isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Derechos</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="RightsCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.RightsCoverage.errors &&
            fValorizationItem.RightsCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura derechos
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="!isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Módulo</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="ModuleCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.ModuleCoverage.errors &&
            fValorizationItem.ModuleCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura derechos
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="!isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Insumos</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="SupplieCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.SupplieCoverage.errors &&
            fValorizationItem.SupplieCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura insumos
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Contraste</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="ContrastCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.ContrastCoverage.errors &&
            fValorizationItem.ContrastCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura contraste
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Descartable</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="DisposableCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.DisposableCoverage.errors &&
            fValorizationItem.DisposableCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura descartable
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Medicamento</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="MedicamentCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.MedicamentCoverage.errors &&
            fValorizationItem.MedicamentCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura medicamento
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isSupplieEdition"
        class="card-inline margin-right-small"
      >
        <mat-label>% Radioactivo</mat-label>
        <input
          type="number"
          max="100"
          min="0"
          matInput
          formControlName="RadioactiveCoverage"
        />
        <mat-error
          *ngIf="
            fValorizationItem.RadioactiveCoverage.errors &&
            fValorizationItem.RadioactiveCoverage.errors.requiedCoverage
          "
        >
          Ingrese la cobertura radioactivo
        </mat-error>
      </mat-form-field>
      <mat-form-field class="card-inline margin-right-small">
        <mat-label>Coseguro</mat-label>
        <input type="number" matInput formControlName="AssuranceAmount" />
      </mat-form-field>

      <mat-form-field
        *ngIf="!isSupplieEdition && canEditAmount"
        class="card-inline margin-right-small"
      >
        <mat-label>Importe honorarios</mat-label>
        <input type="number" min="0" matInput formControlName="FeeAmount" />
        <mat-error
          *ngIf="
            fValorizationItem.FeeAmount.errors &&
            fValorizationItem.FeeAmount.errors.requiedAmount
          "
        >
          Ingrese el importe de honorarios
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="!isSupplieEdition && canEditAmount"
        class="card-inline margin-right-small"
      >
        <mat-label>Importe derechos</mat-label>
        <input type="number" min="0" matInput formControlName="RightsAmount" />
        <mat-error
          *ngIf="
            fValorizationItem.RightsAmount.errors &&
            fValorizationItem.RightsAmount.errors.requiedAmount
          "
        >
          Ingrese el importe derechos
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="!isSupplieEdition && canEditAmount"
        class="card-inline margin-right-small"
      >
        <mat-label>Importe módulo</mat-label>
        <input type="number" min="0" matInput formControlName="ModuleAmount" />
        <mat-error
          *ngIf="
            fValorizationItem.ModuleAmount.errors &&
            fValorizationItem.ModuleAmount.errors.requiedAmount
          "
        >
          Ingrese el importe derechos
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="!isSupplieEdition && canEditAmount"
        class="card-inline margin-right-small"
      >
        <mat-label>Importe insumos</mat-label>
        <input type="number" min="0" matInput formControlName="SupplieAmount" />
        <mat-error
          *ngIf="
            fValorizationItem.SupplieAmount.errors &&
            fValorizationItem.SupplieAmount.errors.requiedAmount
          "
        >
          Ingrese el importe insumos
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button
        *ngIf="canUpdateLikeParticular"
        (click)="saveLikeParticular()"
        mat-button
        type="button"
      >
        Aplica valor Particular
      </button>
      <button mat-button type="submit">Aceptar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
        Salir
      </button>
    </div>
  </div>
</form>
